exports.isValidFile = isValidFile;

function isValidFile(file_path) {
  let ret = true;
  const parts = file_path?.split?.('/');
  if (!file_path) {
    ret = false;
  } else if (parts.find((p) => p[0] === '.')) {
    ret = false;
  }
  return ret;
}
